/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  // const valid_map = ['admin', 'editor']
  // return valid_map.indexOf(str.trim()) >= 0
  const emailReg = /^[a-z\.]+@wondfo.com.cn+$/
  return emailReg.test(str.trim())
}

export function validPhone(str) {
  const reg = /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/
  return reg.test(str)
}

export function validPassword(str) {
  const reg = /^(?![^a-zA-Z]+$)(?!\D+$)/
  return reg.test(str)
}
